import type { PaymentErrorHandler } from "@offstreetparking/portal-flow/components/CreatePermitWizard/components/PaymentForm";
import type { RouterOutputs } from "~/services/offstreetApi/types";
import { useAuthorizeNet } from "../../hooks/useAuthorizeNet/useAuthorizeNet";
import { useCompletePayment } from "../../hooks/useCompletePayment";
type AuthorizeNetFormProps = {
	paymentSession: NonNullable<RouterOutputs["paymentSession"]["createPaymentSessionPublic"]["session"]>;
	formId: string;
	onError: PaymentErrorHandler;
	onSuccess: (publicIdentifier: string) => void;
	setIsProcessing: (isProcessing: boolean) => void;
};
export const AuthorizeNetForm = ({
	paymentSession,
	formId,
	onSuccess,
	onError,
	setIsProcessing,
}: AuthorizeNetFormProps) => {
	const { mutate: completePayment } = useCompletePayment({ platform: "AuthorizeNet", onSuccess, onError });
	const { isReady, openLightbox } = useAuthorizeNet({
		paymentSession,
		callbacks: {
			onApproval: (nonce) => {
				setIsProcessing(true);
				completePayment({
					paymentSessionId: paymentSession.paymentId,
					token: nonce,
				});
			},
			onError: () => onError({ error: { type: "not-charged" } }),
		},
	});
	const handleWizardSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!isReady) {
			return;
		}
		openLightbox();
	};
	return <form id={formId} onSubmit={handleWizardSubmit} />;
};
